import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '../services/common/token.service';
import { BaseService } from '../services/common/base.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BehaviorSubject, observable } from 'rxjs';
import { TreeNode } from 'primeng/api';

@Injectable()
export class FarmerLandDetailService extends BaseService {
    protected http: HttpClient;
    onDatatablessChanged: BehaviorSubject<any>;

    constructor(http: HttpClient, tokenService: TokenService) {
        super(tokenService);
        this.http = http;
        this.onDatatablessChanged = new BehaviorSubject({});
    }
    Get(farmerId: any) {
        // return this.http.get<any>(`${environment.apiUrl}LandDetails/GetByFarmerID?FarmerID=${farmerId}`, { headers: this.buildHeaders() });
        return this.http.get<any>(`${environment.apiUrl}LandDetails/GetByFarmerID?FarmerID=${farmerId}`);
    }

    InsertLandDetails(onFramMiModel: any) {
        // return this.http.post(`${environment.apiUrl}LandDetails/Insert`, onFramMiModel, { headers: this.buildHeaders() });
        return this.http.post(`${environment.apiUrl}LandDetails/Insert`, onFramMiModel);
    }

    UpdateLandDetails(onFramMiModel: any) {
        // return this.http.post(`${environment.apiUrl}LandDetails/Update`, onFramMiModel, { headers: this.buildHeaders() });
        return this.http.post(`${environment.apiUrl}LandDetails/Update`, onFramMiModel);
    }

    DeleteLandDetails(onFramMiModel: any) {
        // return this.http.post(`${environment.apiUrl}LandDetails/Delete`, onFramMiModel, { headers: this.buildHeaders() });
        return this.http.post(`${environment.apiUrl}LandDetails/Delete`, onFramMiModel);
    }

    GetCorpType() {
        // return this.http.get<any>(`${environment.apiUrl}LandDetails/GetCropMaster`, { headers: this.buildHeaders() });
        return this.http.get<any>(`${environment.apiUrl}LandDetails/GetCropMaster`);
    }

    getNotUsedLandsByFarmerID(farmerId: any) {
        return this.http.get<any>(`${environment.apiUrl}LandDetails/GetNotUsedLandsByFarmerID?FarmerID=${farmerId}`);
    }

    landDetailsInsert_CR(reqBody: any) {
        return this.http.post(`${environment.apiUrl}ChangeRequest/LandDetailsInsert_CR`, reqBody);
    }

    getAreaByLandId(landId: any) {
        return this.http.get<any>(`${environment.apiUrl}OnFormMI/GetAreaByLandId?LandId=${landId}`);
    }
    getPreEstimateSurvey(reqBody:any):any {
        return this.http.post(`${environment.apiUrl}DashBoard/InsertPreEstimateSurveyDetails`, reqBody);
    }
}